<span class="icon fb-xfbml-parse-ignore" (click)="share()">
    <app-icon *ngIf="!simpleIcon" [type]="'Facebook'"></app-icon>
    <app-icon *ngIf="simpleIcon" [type]="'facebook-simple'"></app-icon>
</span>
